import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react'

import { IncidentSubject } from './typing'

type Context = {
  subject?: IncidentSubject
  setSubject: (subject?: IncidentSubject) => void
}

const CurrentSubjectContext = createContext<Context>({ setSubject: () => {} })

export const CurrentIncidentSubjectProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [subject, setSubject] = useState<IncidentSubject>()

  return (
    <CurrentSubjectContext.Provider value={{ subject, setSubject }}>
      {children}
    </CurrentSubjectContext.Provider>
  )
}

export const useCurrentIncidentSubject = () => useContext(CurrentSubjectContext).subject

export const useRegisterIncidentSubject = (subject?: IncidentSubject) => {
  const { setSubject } = useContext(CurrentSubjectContext)

  useEffect(() => {
    setSubject(subject)
    return () => setSubject(undefined)
  }, [subject?.type, subject?.id, subject?.label])
}
